
class Tag {
  constructor(data) {
    Object.assign(this, data);    

    this.name = this.name || "";
    this.type = this.type || "";
    this.category = this.category || "";
    this.icon = this.icon || "";
    this.sort = this.sort || 0;
  }
}

export default Tag;
